import ImageWithFallback from '@components/image/ImageWithFallback'
import { CheckCircleIcon } from '@heroicons/react/20/solid'
import { localStorageKey, useLocalStorage } from 'hooks/useLocalStorageState'
import { useTranslation } from 'next-i18next'

const EXPLORERS = [
  {
    name: 'solana-explorer',
    url: 'https://explorer.solana.com/',
    addressParam: 'address/',
    transactionParam: 'tx/',
  },
  {
    name: 'solscan',
    url: 'https://solscan.io/',
    addressParam: 'account/',
    transactionParam: 'tx/',
  },
  {
    name: 'solana-beach',
    url: 'https://solanabeach.io/',
    addressParam: 'address/',
    transactionParam: 'transaction/',
  },
  {
    name: 'solanafm',
    url: 'https://solana.fm/',
    addressParam: 'address/',
    transactionParam: 'tx/',
  },
] as const
type PreferredExplorer = (typeof EXPLORERS)[number]
export const PREFERRED_EXPLORER_KEY = localStorageKey<PreferredExplorer>(
  'preferredExplorer-0.1',
  EXPLORERS[0],
)

const PreferredExplorerSettings = () => {
  const { t } = useTranslation('settings')
  const [preferredExplorer, setPreferredExplorer] = useLocalStorage(
    PREFERRED_EXPLORER_KEY,
  )
  return (
    <div className="pt-6">
      <h3 className="mb-4 text-base text-th-fgd-1">
        {t('preferred-explorer')}
      </h3>
      <div className="space-y-2">
        {EXPLORERS.map((ex) => (
          <button
            className="flex w-full items-center justify-between rounded-md border border-th-bkg-4 p-4 hover:border-th-fgd-4"
            onClick={() => setPreferredExplorer(ex)}
            key={ex.name}
          >
            <div className="flex items-center space-x-2">
              <ImageWithFallback
                alt=""
                width={24}
                height={24}
                src={`/explorer-logos/${ex.name}.png`}
              />
              <p>{t(ex.name)}</p>
            </div>
            {preferredExplorer.url === ex.url ? (
              <CheckCircleIcon className="size-5 text-th-success" />
            ) : null}
          </button>
        ))}
      </div>
    </div>
  )
}

export default PreferredExplorerSettings
